<script lang="ts">
  /**
  *
  * Authentication.svelte
  *
  * Desc: Page. for authentication
  *
  * Author : Sebastien Hoarau, Dmytro Teliakovskyi
  *
  * Project : cocolake
  *
  */


  // Applications
  import { login, getEmail } from '../../application/UserController';
  import { getCountryBU } from '../../application/UserCrmController';

  // Utils
  import { navigate } from '../../../../helpers/Navigation';
  

  async function handleClick() {
    await login();
    getCountryBU(getEmail());
    navigate('/');
  }
</script>

<section class="login">
  <img class="login__brand" src="/images/bertek-negative-logo.png" alt="Bertek" />
  <div class="login__content">
    <h1>Coco<span>Lake</span></h1>
    <p>Explore <span class="login__wordmark">Bert<span>e</span>k</span>’s talent pool</p>
    <button type="button" on:click={handleClick}>Sign in</button>
  </div>
  <img class="login__illustration" src="/images/sourcing-illustration.svg" alt="" aria-hidden="true" />
  <div class="login__animation" aria-hidden="true">
    {#each Array(7) as _}
      <div class="square"></div>
    {/each}
  </div>
</section>

<style lang="scss">
  .login {
    position: relative;
    isolation: isolate;
    min-height: 100vh;
    min-height: 100svh;
    padding: 100px 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fafafa;
    overflow: hidden;
    background: #0a0a0a;
  }
  .login__brand {
    position: absolute;
    top: 24px;
    left: 24px;
    display: block;
    width: 128px;
    height: auto;
  }
  .login__content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 440px;
    background: #0a0a0a;
    text-align: center;
  }
  h1 {
    font-family: "Space Grotesk", Arial, sans-serif;
    font-size: clamp(56px, 8vw, 80px);
    font-weight: 600;
    line-height: 1.15;
    margin-bottom: 8px;
    span { color: #36f778; }
  }
  p {
    font-size: clamp(20px, 2.5vw, 24px);
    font-weight: 400;
    color: #b5b5b5;
    line-height: 1.5;
    margin: 20px 0 16px;
  }
  .login__wordmark {
    color: #fff;
    font-family: "Space Grotesk", Arial, sans-serif;
    font-weight: 600;
    span { color: #36f778; }
  }
  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;
    padding: 16px 38px;
    background: #36f778;
    color: #0a0a0a;
    border: 1px solid #36f778;
    border-radius: 6px;
    font-size: 19px;
    font-weight: 600;
    line-height: 1.5;
    cursor: pointer;
    transition: background-color 200ms, border-color 200ms;
    &:hover { background: #0fb84a; border-color: #0fb84a; }
    &:focus-visible { outline: 2px solid #36f778; outline-offset: 4px; }
  }
  .login__illustration { display: none; }
  @media (min-width: 1101px) {
    .login__illustration {
      position: absolute;
      left: calc(75% + 110px);
      top: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: min(560px, calc(50% - 220px));
      height: auto;
      pointer-events: none;
    }
  }
  .login__animation { position: absolute; inset: 0; z-index: -1; pointer-events: none; }
  .square {
    position: absolute;
    width: 50px;
    height: 50px;
    background: #36f778;
    border-radius: 3px;
    top: 100%;
    left: 25%;
    animation: move 10s linear infinite;
    &:nth-last-of-type(2) { left: 112px; animation-delay: 3.5s; width: 24px; height: 24px; }
    &:nth-last-of-type(3) { left: 224px; animation-delay: 3s; }
    &:nth-last-of-type(4) { left: 336px; animation-delay: 5.5s; }
    &:nth-last-of-type(5) { left: 448px; animation-delay: 1.8s; width: 104px; height: 104px; }
    &:nth-last-of-type(6) { left: 224px; animation-delay: 6.8s; width: 40px; height: 40px; }
    &:nth-last-of-type(7) { left: 448px; animation-delay: 5s; width: 56px; height: 56px; }
  }
  @keyframes move {
    to { top: -80px; transform: rotate(360deg); }
  }
</style>
